import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import Blog from "@/pages/Blog";
import { blogPostsQueryOptions } from '@/lib/blogQueries';
import { BlogLoadError, BlogNotFound } from '@/components/blog/BlogRouteStatus';

export const Route = createFileRoute("/blog/")({
  loader: async ({ context }) => { await context.queryClient.ensureQueryData(blogPostsQueryOptions()); },
  errorComponent: BlogLoadError,
  notFoundComponent: BlogNotFound,
  head: () => pageHead({
    title: 'RV Blog',
    description: 'Tips, news and stories from Rex & Sons RVs — RV lifestyle, maintenance advice and dealership updates from Castle Hayne, NC.',
    path: '/blog',
  }),
  component: Blog,
});